import { HTTPError } from "ky";

import { logOut } from "@/redux/actions/logout";
import { showToast } from "@/providers/ToastProvider";
import store from "@/redux/store";

const dispatch = store.dispatch;

// Prevents concurrent 403 callers from dispatching logOut more than once.
// All callers share the same refresh promise; their catch blocks fire together
// when it rejects. Once the redirect timer is set there is nothing more to do.
let isLoggingOut = false;

// Only exported for test teardown — resets the guard between test runs.
export function __resetLoggingOut(): void {
  isLoggingOut = false;
}

// Shows a session-expired toast and schedules a redirect to sign-in.
// Only fires when new_id_token returns 401 after exhausting its retry —
// two consecutive 401s is our best signal for a genuinely expired refresh
// token. Non-401 failures (network errors, server outages) leave the user
// on the page to avoid a jarring redirect during an unrelated backend issue.
// The 1.5 s delay lets the toast render before the page navigates away.
const SESSION_EXPIRED_REDIRECT_MS = 1500;

// Shared by refreshAuthTokenHook and refreshWorkflowTokenHook.
export function handleSessionExpired(err: unknown): void {
  if (!(err instanceof HTTPError) || err.response.status !== 401 || isLoggingOut) return;
  isLoggingOut = true;
  showToast([
    { heading: "Session expired", text: "Please sign in to continue.", variant: "warning" },
  ]);
  setTimeout(() => dispatch(logOut()), SESSION_EXPIRED_REDIRECT_MS);
}
